import { styled, ToggleButtonGroup } from '@mui/material';
import Box from '@mui/material/Box';
import MuiToggleButton from '@mui/material/ToggleButton';

export const Header = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.background.default}`,
  display: 'flex',
  height: '56px',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  width: '100%',
}));

export const ToggleButton = styled(MuiToggleButton)(({ theme }) => ({
  color: theme.palette.primary.light,
  width: '50%',
  border: 'none',
  textTransform: 'none',
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.dark,
  },
  borderRadius: '2px',
  '&:hover': { backgroundColor: 'transparent', color: '#9E9E9E' },
}));

export const ToggleButtonPanel = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected': {
    borderRadius: '2px',
  },
  height: '40px',
  width: '100%',
  marginBottom: theme.spacing(2),
  borderRadius: '2px',
  border: `4px solid ${theme.palette.background.default}`,
  backgroundColor: theme.palette.background.default,
}));
